/* eslint-disable @next/next/no-img-element */
/* eslint-disable eqeqeq */
import React from "react";
import { getAssets } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import styles from "./MediaBox.module.scss";
import { RiCheckboxBlankLine, RiCheckboxFill } from "react-icons/ri";

export const MediaBox = (props) => {
  const { src, mimetype, mediaName } = props.data;

  const handleClick = () => {
    if (props.onClick) props.onClick(props.data);
  };

  const PreviewItem = (src) => {
    const extension = src.split(".").pop();

    const imagePath = src || getAssets("assets/images/vector-image.png");

    if (extension == "pdf" || mimetype == "application/pdf") {
      return (
        <div className={styles.filterArea}>
          <div className={styles.checkIcon}>
            {props.is_selected ? <RiCheckboxFill /> : <RiCheckboxBlankLine />}
          </div>
          <div className={styles.icon_wrapper}>
            <ReactSVG
              className={styles.icon}
              src={getAssets("assets/icons/pdf_icon.svg")}
            />
          </div>

          <div className={styles.name}>
            <h4>{mediaName || ""} </h4>
            {/* <p>
              <span className={styles.date}>10th Dec, 2021 </span>{" "}
              <span className={styles.uploader}>by John Wick</span>
            </p> */}
          </div>
        </div>
      );
    }

    if (
      extension == "xls" ||
      extension == "xlsx" ||
      mimetype == "application/xlsx"
    ) {
      return (
        <div className={styles.filterArea}>
          <div className={styles.checkIcon}>
            {props.is_selected ? <RiCheckboxFill /> : <RiCheckboxBlankLine />}
          </div>
          <div className={styles.icon_wrapper}>
            <ReactSVG
              className={styles.icon}
              src={getAssets("assets/icons/xls_icon.svg")}
            />
          </div>
          <div className={styles.name}>
            <h4>{mediaName || ""} </h4>
            {/* <p>
              <span className={styles.date}>10th Dec, 2021 </span>{" "}
              <span className={styles.uploader}>by John Wick</span>
            </p> */}
          </div>
        </div>
      );
    }

    if (
      extension == "docx" ||
      extension == "doc" ||
      mimetype ==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      mimetype == "application/doc"
    ) {
      return (
        <div className={styles.filterArea}>
          <div className={styles.checkIcon}>
            {props.is_selected ? <RiCheckboxFill /> : <RiCheckboxBlankLine />}
          </div>
          <div className={styles.icon_wrapper}>
            <ReactSVG
              className={styles.icon}
              src={getAssets("assets/icons/doc_icon.svg")}
            />
          </div>
          <div className={styles.name}>
            <h4>{mediaName || ""} </h4>
            {/* <p>
              <span className={styles.date}>10th Dec, 2021 </span>{" "}
              <span className={styles.uploader}>by John Wick</span>
            </p> */}
          </div>
        </div>
      );
    }

    if (
      extension == "jpg" ||
      extension == "png" ||
      extension == "svg" ||
      extension == "webp" ||
      mimetype == "image/jpeg" ||
      mimetype == "image/svg+xml" ||
      mimetype == "image/png"
    ) {
      return (
        <div className={styles.imageArea}>
          <div className={styles.checkIcon}>
            {props.is_selected ? <RiCheckboxFill /> : <RiCheckboxBlankLine />}
          </div>
          <div className={styles.mediaContent}>
            <img src={imagePath} alt="" />
          </div>

          <div className={styles.name}>
            <h4>{mediaName || ""} </h4>
            {/* <p>
              <span className={styles.date}>10th Dec, 2021 </span>{" "}
              <span className={styles.uploader}>by John Wick</span>
            </p> */}
          </div>
        </div>
      );
    }

    if (extension == "mp4" || mimetype == "video/mp4") {
      return (
        <div className={styles.filterArea}>
          <div className={styles.icon_wrapper}>
            <ReactSVG
              className={styles.icon}
              src={getAssets("assets/icons/video_icon.svg")}
            />
          </div>
          <div className={styles.name}>
            <h4>{mediaName || ""} </h4>
            {/* <p>
            <span className={styles.date}>10th Dec, 2021 </span>{" "}
            <span className={styles.uploader}>by John Wick</span>
          </p> */}
          </div>
        </div>
      );
    }

    // <div className={styles.filterArea}>
    //   <video width="100%" height="130" controls="controls" preload="none">
    //     <source src={imagePath} type="video/mp4" autostart="false" />
    //     Your browser does not support the video tag.
    //   </video>
    //   <span className={styles.name}> {mediaName || ""} </span>
    // </div>;

    return (
      <div className={styles.imageArea}>
        <div className={styles.checkIcon}>
          {props.is_selected ? <RiCheckboxFill /> : <RiCheckboxBlankLine />}
        </div>
        <div className={styles.mediaContent}>
          <img src={imagePath} alt="" />
        </div>

        <div className={styles.name}>
          <h4>{mediaName || ""} </h4>
          {/* <p>
              <span className={styles.date}>10th Dec, 2021 </span>{" "}
              <span className={styles.uploader}>by John Wick</span>
            </p> */}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`${props.is_selected ? styles.selected : styles.button}`}
      onClick={() => handleClick()}
      style={{ height: "100%" }}
    >
      {PreviewItem(src)}
    </div>
  );
};

export default MediaBox;
